import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unselectable",
  "use": "icon-unselectable-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" class=\"design-iconfont\" id=\"icon-unselectable\">\n  <path d=\"M273 17.5A9.5 9.5 0 1 0 273 36.5A9.5 9.5 0 1 0 273 17.5Z\" transform=\"translate(-263 -17)\" stroke=\"#E8AB79\" fill=\"none\" fill-rule=\"evenodd\" opacity=\".29613095\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol